import { UsageType } from './usageEventType';
import { DatePipe } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { Uuid } from 'src/app/shared/classes/uuid';
export class UsageEventBase {

    private datePipe: DatePipe = new DatePipe('en-US');

    currentDate = new Date();
    currentMn = this.currentDate.getMonth();
    currentYr = this.currentDate.getFullYear();
    // Identity fields
    clientName: string;
    aviClientId: number;
    product: string;
    category: string;
    value: number;
    // isValueCount: boolean;
    description: string;
    manualUsageEventType: UsageType;
    manualUsageEventId: string;
    dataLineageId?: string;
    month: number;
    year: number;

    // Additional fields
    // accountNumber: string;
    siteName: string;
    city: string;
    state: string;
    zip: string;

    constructor(model: FormGroup) {
      console.log('in base class constructor');
      //this.manualUsageEventId = model.get('manualUsageEventId').value || Uuid.createV4();
      //this.dataLineageId = model.get('dataLineageId').value || null;

      this.manualUsageEventId = model.controls.manualUsageEventId.value || Uuid.createV4();
      this.dataLineageId = model.controls.dataLineageId.value || null;


      this.clientName	=  '';
      this.aviClientId =  model.get('aviClientId').value;
      this.product =  model.get('product').value;
      this.category =  model.get('category').value;
      this.value =  model.get('value').value;
      // this.isValueCount = false;
      this.description =  model.get('description').value;
      this.manualUsageEventType =  model.get('usageType').value;
      this.siteName = model.get('siteGroup.siteName').value;
      this.city = model.get('siteGroup.city').value;
      this.state = model.get('siteGroup.state').value;
      this.zip = model.get('siteGroup.zip').value;

      // js time uses month index (0-11)
      // need to convert it to (1-12) index
      if(Number(model.get('month').value) === this.currentMn)
      {
        this.month = Number(model.get('month').value) + 1;
        this.year = this.currentYr;
      }
      else  // prev month logic
      {
        if(Number(model.get('month').value) === 11)
        {
          this.month = 12;
          this.year =  this.currentYr - 1;
        }
        else
        {
          this.month = Number(model.get('month').value) + 1;
          this.year = this.currentYr;
        }
      }

    }
  }
